import React from 'react'

export const GenericInput = ({ name, register, errors, validationMessage = 'Campo requerido', label, placeholder, required, type = "text" }) => {

    const today = new Date().toISOString().split('T')[0]

    return (
        <div className="form-floating">
            <input
                type={type}

                min={type === 'date' ? today : undefined}

                className={`form-control form-control-height ${errors[name] ? 'inError' : ''}`}
                name={name}
                {...register(name, {
                    ...(required && { required: validationMessage }),
                    ...(type === "number" && { valueAsNumber: true }),
                    min: {
                        value: 0,
                        message: "No se permiten números negativos"
                    }
                })}
                id={`floatingInput-${name}`}
                placeholder={placeholder ?? " "}
            />
            <label className="label-floating" htmlFor={`floatingInput-${name}`}>
                {label}
            </label>

            {errors[name] && (
                <span className='invalid-feedback d-flex field-validation-error'>
                    <span className="error-message">{errors[name]?.message}</span>
                </span>
            )}
        </div>
    )
}
